export const UPDATE_SERVICES = 'UPDATE_SERVICES'
export const UPDATE_SERVICE = 'UPDATE_SERVICE'
export const DELETE_SERVICE = 'DELETE_SERVICE'
export const CHANGE_PROGRESS = 'CHANGE_PROGRESS'
export const SET_SERVICE_FORM_VALIDATION_ERRORS = 'SET_SERVICE_FORM_VALIDATION_ERRORS'
export const RESET_SERVICE_FORM_VALIDATION_ERRORS_BY_FIELD = 'RESET_SERVICE_FORM_VALIDATION_ERRORS_BY_FIELD'
export const INIT_SERVICE_FORM_CONTEXT = 'INIT_SERVICE_FORM_CONTEXT'
export const CHANGE_SERVICE_FORM_FIELD = 'CHANGE_SERVICE_FORM_FIELD'
export const CHANGE_SERVICE_FORM_VALIDATION = 'CHANGE_SERVICE_FORM_VALIDATION'

export const UPDATE_CLIENT_SERVICES = 'UPDATE_CLIENT_SERVICES'
export const UPDATE_CLIENT_SERVICE = 'UPDATE_CLIENT_SERVICE'
export const DELETE_CLIENT_SERVICE = 'DELETE_CLIENT_SERVICE'
